// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_24jaD","gift-box-wrapper":"d_msd","gift-box":"_1Ij6E","speech-bubble":"lWodk","gift-open-svg":"_3Jod0","cross-icon":"_2Xone"};